export const MAX_SELECT = 10000;
